import React, { FC, useCallback } from 'react';
import type { ILegoElemProps } from '../../Lego';
import { useLegoFormContext } from '../../_FormProvider/useLegoFormContext';
import { ILegoElemRadioButton } from '../models';
import { RadioButton } from '@src/atoms/RadioButton';

export const LegoElemRadioButton: FC<ILegoElemProps> = ({ elem }) => {
  const legoElem = elem as ILegoElemRadioButton;
  const { formHook } = useLegoFormContext();
  const value = formHook.watch(elem.id);

  const handleOnChange = useCallback(
    (newValue: string) => {
      formHook.setValueAndRevalidate(elem.id, newValue);
    },
    [elem.id, formHook],
  );

  return (
    <RadioButton
      options={legoElem.radioButton.options}
      value={value}
      onChange={handleOnChange}
      id={elem.id}
      className={legoElem.radioButton.className}
      style={legoElem.radioButton.style}
      view={legoElem.radioButton.view}
    />
  );
};
